// String-grid sprites for the forge scene. One character per pixel; '.' is transparent.
import type { Grid, Palette } from './engine';

export const SCENE_PAL: Palette = {
  k: '#05040A', // outline
  y: '#3A2A22', // hair / beard
  Y: '#5C4331',
  s: '#E3AC7E', // skin
  S: '#B07850',
  q: '#7FE0FF', // goggle lenses (quench)
  g: '#4A4560', // iron
  G: '#6E6886',
  l: '#A9A2C0', // polished steel
  t: '#3B3358', // shirt
  T: '#2A2440',
  a: '#8A4A2E', // leather apron
  A: '#5E2E1C',
  b: '#6A3F24', // wood
  B: '#3E2414',
  o: '#8C5A34',
  u: '#B7773A', // bronze buckle
  w: '#F2EAD8',
};

/** The smith, facing right, without the hammer arm (drawn per pose). 16 x 31. */
const SMITH: Grid = [
  '.....kkkkk......',
  '....kyyyyyk.....',
  '...kyyyyyyyk....',
  '...kyyyggggk....',
  '...kyykqqkqk....',
  '...kyksssssk....',
  '...kyssssksk....',
  '...kkssssssSk...',
  '....kSssssskk...',
  '....kyYyYyyk....',
  '.....kyyyyk.....',
  '....kkSSSkkk....',
  '...kttttttttk...',
  '..ktTaaaaaaatk..',
  '..ktTaaaaaaatk..',
  '..ktTaaaaaaak...',
  '..kSTaaaaaaak...',
  '..kkTaaaaaaak...',
  '...kTaaaaaaak...',
  '...kbbbbbubbk...',
  '...kAaaaaaaak...',
  '...kAaaaaaaak...',
  '...kAaaakaaak...',
  '...kTTTk.kTTk...',
  '...kTTTk.kTTk...',
  '...kTTTk.kTTk...',
  '...kTTTk.kTTk...',
  '...kTTTk.kTTk...',
  '..kBBBBk.kBBBk..',
  '..kBBBBk.kBBBBk.',
  '..kkkkkk.kkkkkk.',
];

/** Same smith with closed eyes (blink frame). */
const SMITH_BLINK: Grid = SMITH.map((r, i) => (i === 6 ? '...kyssssssk....' : r));

const ANVIL: Grid = [
  'kkkkkkkkkkkkkkkkkkkkkkkk',
  'kllllllllllllllllllllllk',
  '.kGGGGGGGGGGGGGGGGGGGGGk',
  '..kkkkggggggggggggggggk.',
  '......kkggggggggggggkk..',
  '........kggggggggggk....',
  '........kggggggggggk....',
  '......kkggggggggggggkk..',
  '.....kGggggggggggggggGk.',
  '.....kkkkkkkkkkkkkkkkkk.',
];

const STUMP: Grid = [
  'kkkkkkkkkkkkkkkk',
  'kobbbbobbbbbbbBk',
  'kbbBbbbbbbBbbbBk',
  'kkkkkkkkkkkkkkkk',
];

const HORSESHOE: Grid = ['.kkkkk.', 'kgGGGgk', 'kgk.kgk', 'kgk.kgk', 'kgk.kgk', 'kGk.kGk', 'kkk.kkk'];

const TONGS: Grid = ['..k..', '.kgk.', '.kgk.', '.kgk.', 'kgkgk', 'kgkgk', 'kg.gk', 'kg.gk', 'kg.gk', 'kg.gk', 'kk.kk'];

const PEG: Grid = ['kk', 'bk'];

export const SCENE_SPRITES: Readonly<Record<string, Grid>> = {
  smith: SMITH,
  smithBlink: SMITH_BLINK,
  anvil: ANVIL,
  stump: STUMP,
  horseshoe: HORSESHOE,
  tongs: TONGS,
  peg: PEG,
};
